// src/assets/js/securityapi.js
import SecurityService from './SecurityService';

const svc = new SecurityService();

export default async function defineHeaderAxios() {
  const token = await svc.getAcessToken();
  return token || '';
}
